import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { DictService } from '../../../routes/jy-dict/dict-info/service/dict.service';
import { CommonsService } from '../../../core/service/commons.service';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CacheService } from '@delon/cache';

export const EXE_COUNTER_VALUE_ACCESSOR:any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => DictSearchrComponent),
  multi: true
};
/**
 * 字典组件
 * 若要多选,mode传multiple,dictItemCode以逗号分隔
 */
@Component({
  selector: 'dict-search',
  template: `
    <nz-select  nzShowSearch nzAllowClear [nzPlaceHolder]="disabled?null:'commons.info.pleaseSelect'|translate" required="{{required}}" name="{{name}}"
    [(ngModel)]="innerValue" [nzDisabled]="disabled" [nzMode] ="mode" (ngModelChange)="changeVal($event)">
      <ng-container *ngFor="let dictItem of dictitemList">
        <nz-option *ngIf="((selectMemo && dictItem.describe == selectMemo) || !selectMemo) && ((filterCode && dictItem.code != filterCode) || !filterCode)" [nzLabel]="showCode?dictItem['code']+' '+dictItem[valueType]:dictItem[valueType]" [nzValue]="dictItem.code" nzCustomContent >
          <span [title]="dictItem['code'] + ' ' + dictItem[valueType]"><span *ngIf="showCode">{{dictItem['code']}}&nbsp;&nbsp;</span>{{dictItem[valueType]}}</span>
        </nz-option>
      </ng-container>
    </nz-select>`,
  styleUrls: ['./dict-search.less'],
  providers: [EXE_COUNTER_VALUE_ACCESSOR]
})

export class DictSearchrComponent implements OnInit, ControlValueAccessor {
  @Output() private onChange = new EventEmitter();
  propagateChange = (_:any) => {
  };

  writeValue(obj:any):void {
    if ("multiple" == this.mode && obj) {
      this.innerValue = obj.split(",")
    } else {
      this.innerValue = obj;
    }
  }

  registerOnChange(fn:any):void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn:any):void {
  }

  changeVal(val) {
    this.onChange.emit(val);
    if ("multiple" == this.mode && val) {

      this.propagateChange(val.join(","));
    } else {
      this.propagateChange(val);
    }
  }

  ngOnInit():void {
    this.getItems()
  }


  /**
   * 下拉框类型,default:单选   multiple:多选
   */
  @Input() mode:string;

  @Input() name:string;

  /**
   * 是否显示编号
   */
  @Input() filterCode:String;

  /**
   * 是否显示编号
   */
  @Input() showCode:boolean = true;
  /**
   * 是否必填
   */
  @Input() required:boolean;
  /**
   * 是否禁用
   */
  @Input() disabled:boolean;
  /**
   * 字典code
   */
  @Input() dictCode:string;
  /**
   * 英文环境时是否显示英文,默认否
   */
  @Input() allowEnglish:boolean;

  /**
   * 根据字典表说明做条件筛选
   * */
  @Input() selectMemo:string;

  valueType = 'value';

  constructor(private dictService:DictService, private commonsService:CommonsService, private srv:CacheService) {
    this.required = false;
    this.disabled = false;
    this.allowEnglish = false;
    this.mode = "default";
  }


  innerValue:any = 'value2';
  dictitemList:any = [];

  getItems() {
    this.dictitemList = [];
    if (this.dictCode) {
      if (this.allowEnglish && this.commonsService.currentLang == 'en') {
        this.valueType = 'engValue';
      } else {
        this.valueType = 'value';
      }
      var value = this.srv.getNone(this.dictCode);
      if (value) {
        this.dictitemList = value;
      } else {
        this.dictService.getWithItemList(this.dictCode).subscribe((data)=> {
          this.dictitemList = data.dictItems;
          this.srv.set(this.dictCode, this.dictitemList)
        });
      }
    }
  }


  onChangeCallback = (value:any) => {
  };

  get dictItemCode():any {
    return this.innerValue;
  }

  // @Output() innerValueChange = new EventEmitter<any>();

}
